import AdminLoginLayout from "./admin_login_layout";

const AdminLoginPage = () => {
  return (
      <AdminLoginLayout />
  );
};

export default AdminLoginPage;